import {
  GET_OUTREACH_PENDING,
  GET_OUTREACH_FAIL,
  GET_OUTREACH_SUCCESS,
  UPDATE_OUTREACH_PENDING,
  UPDATE_OUTREACH_FAIL,
  UPDATE_OUTREACH_SUCCESS,
  UPDATE_OUTREACH_STATUS,
  SET_OUTREACH,
  GET_OUTREACHES_PENDING,
  GET_OUTREACHES_FAIL,
  GET_OUTREACHES_SUCCESS,
  UPDATE_OUTREACH_STATUS_BULK,
  UPDATE_OUTREACH_READ_BULK,
  UPDATE_BULK_OUTREACHES_PENDING,
  UPDATE_BULK_OUTREACHES_FAIL,
  UPDATE_BULK_OUTREACHES_SUCCESS,
} from '../actions/outreachActions';


const initialState = {
  outreach: {
    loading: true,
    loaded: false,
    id: null,
    messages: [],
    thread_status: {
      code: null,
      verbose: null,
    },
    pitch: {
      subject: null,
      body: null,
    },
    status_spam_date: null,
    created_date: null,
  },
  outreaches: {
    loading: true,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
  },
};

export const outreachReducer = (state = initialState.outreach, action) => {
  switch (action.type) {
    case GET_OUTREACH_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case GET_OUTREACH_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_OUTREACH_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case SET_OUTREACH:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_OUTREACH_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case UPDATE_OUTREACH_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_OUTREACH_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};


export const outreachesReducer = (state = initialState.outreaches, action) => {
  switch (action.type) {
    case GET_OUTREACHES_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case GET_OUTREACHES_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_OUTREACHES_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_BULK_OUTREACHES_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case UPDATE_BULK_OUTREACHES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_BULK_OUTREACHES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_OUTREACH_STATUS: {
      const stateCopy = { ...state };
      const { newStatus, id: idToMod } = action.payload;
      // modify exisiting outreach with new status
      for (let i = 0; i < stateCopy.results.length; i += 1) {
        if (stateCopy.results[i].id === idToMod) stateCopy.results[i].thread_status = newStatus;
      }
      return stateCopy;
    }
    case UPDATE_OUTREACH_STATUS_BULK: {
      const stateCopy = { ...state };
      const { newStatus, ids: idsToMod } = action.payload;
      // modify exisiting outreaches with new status
      for (let i = 0; i < stateCopy.results.length; i += 1) {
        if (idsToMod.includes(stateCopy.results[i].id)) stateCopy.results[i].thread_status = newStatus;
      }
      return stateCopy;
    }
    case UPDATE_OUTREACH_READ_BULK: {
      const stateCopy = { ...state };
      const { ids: idsToMod } = action.payload;
      // modify exisiting outreaches as read
      for (let i = 0; i < stateCopy.results.length; i += 1) {
        if (idsToMod.includes(stateCopy.results[i].id)) stateCopy.results[i].messages[0].is_read = true;
      }
      return stateCopy;
    }
    default:
      return state;
  }
};
